var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_1292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40611 7.97027C8.02004 8.40943 7.55011 8.77058 7.02137 9.03108V10.5311C7.02137 10.6637 6.9687 10.7909 6.87493 10.8846C6.78116 10.9784 6.65398 11.0311 6.52137 11.0311H3.52137C3.38877 11.0311 3.26159 10.9784 3.16782 10.8846C3.07405 10.7909 3.02137 10.6637 3.02137 10.5311V9.03108C2.30182 8.67405 1.69095 8.13094 1.25217 7.45811C0.813399 6.78528 0.562715 6.00727 0.52615 5.20485C0.489585 4.40242 0.66847 3.60484 1.04423 2.89489C1.42 2.18495 1.97894 1.58852 2.66304 1.16754C3.34714 0.746553 4.13146 0.516354 4.93457 0.50084C5.60458 0.487896 6.26729 0.62477 6.87493 0.899421",
    stroke: "#00BA19",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02148 13.5H7.02148",
    stroke: "#00BA19",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39406 3.93395C7.04313 3.8729 7.04313 3.36912 7.39406 3.30807C8.66541 3.08689 9.6766 2.11853 9.95255 0.857921L9.97371 0.761292C10.0496 0.414459 10.5435 0.4123 10.6224 0.758456L10.6481 0.871066C10.9343 2.12572 11.9457 3.08591 13.2136 3.30647C13.5663 3.36784 13.5663 3.87418 13.2136 3.93554C11.9457 4.15611 10.9343 5.1163 10.6481 6.37095L10.6224 6.48356C10.5435 6.82972 10.0496 6.82756 9.97371 6.48073L9.95255 6.3841C9.6766 5.1235 8.66541 4.15513 7.39406 3.93395Z",
    stroke: "#00BA19",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_1292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.308f17ef8ff04ae82834c86c4fc3cd1a.svg";
export { ForwardRef as ReactComponent };